import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Col, Row, Tab, Nav, NavItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { openChapters, toArray } from '../common/util';
import {createResource, deleteResource, updateResource, fetchSections, createResourceContribution} from '../redux/actions';
import {
    authSelector,
    chapterSelector, dkpSelector,
} from "../redux/selectors";
import {hasPermission} from '../common/permissions';
import ResourceList from './ResourceList';


class Resources extends Component {
    constructor(props) {
        super(props);

        this.newResource = this.newResource.bind(this);
        this.editResource = this.editResource.bind(this);
        this.delResource = this.delResource.bind(this);
        this.newResourceControbution = this.newResourceContribution.bind(this);
    }
    componentDidMount() {
        document.title = "Addiction | Guild Management | DKP | Resources";
        openChapters(this.props.chapters)
            .filter(chapter => chapter.game.title !== "Addiction")
            .map((chapter) => {
                this.props.getSections(chapter.id);
                return null;
            });
    }

    newResource = (values) => {
        this.props.submitNewResource(values.chapter.id, values.section.slug, values);
    };

    editResource = (values) => {
        this.props.submitEditResource(values.chapter.id, this.props.dkp.data[values.section].slug, values.slug, values);
    };

    delResource = (data) => {
        this.props.submitDeleteResource(data.chapter.id, data.section.slug, data.resource.slug)
    };

    newResourceContribution = (values) => {
        let newValues = {
            ...values,
            user: {
                slug: values.user
            }
        };
        this.props.submitNewResourceContribution(values.chapter.id, this.props.dkp.data[values.section].slug, values.slug, newValues)
    }

    render() {
        if (hasPermission('dkp.change_resource',this.props.auth.permissions) || hasPermission('dkp.add_resource', this.props.auth.permissions)) {
            return (
                <div>
                    <h1>Resources</h1>
                    <div className="panel">
                        <Tab.Container id="resources" defaultActiveKey="0-resources">
                            <Row className="clearfix">
                                <Col xs={18} md={12}>
                                    <Nav bsStyle="pills">
                                    {
                                        openChapters(this.props.chapters)
                                            .filter(chapter => chapter.game.title !== "Addiction")
                                            .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                            .map((chapter, i) => (
                                            <NavItem eventKey={`${i}-resources`} key={`${i}-resources`}>
                                                <h3>{chapter.game.title} </h3>
                                            </NavItem>
                                        ))
                                    }
                                    </Nav>
                                </Col>
                                <Col xs={18} md={12}>
                                    <Tab.Content animation>
                                        { openChapters(this.props.chapters)
                                            .filter(chapter => chapter.game.title !== "Addiction")
                                            .sort((a, b) => (new Date(b.openDate).getTime() - new Date(a.openDate).getTime()))
                                            .map((chapter, i) => (
                                            <Tab.Pane eventKey={`${i}-resources`} key={`${i}-resources`}>

                                                <Tab.Container id="section" defaultActiveKey="0-section">
                                                    <Row className="clearfix">
                                                        <Col xs={18} md={12}>
                                                            <Nav bsStyle="pills">
                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                    .map((dkp, i) => (
                                                                        <NavItem eventKey={`${i}-section`} key={`${i}-section`}>
                                                                            <h3>{dkp.title}</h3>
                                                                        </NavItem>
                                                                    ))
                                                                }
                                                            </Nav>
                                                        </Col>
                                                        <Col xs={18} md={12}>
                                                            <Tab.Content animation>
                                                                { toArray(this.props.dkp.data).filter(dkp => dkp.chapter === chapter.id)
                                                                    .map((dkp, i) => (
                                                                        <Tab.Pane eventKey={`${i}-section`} key={`${i}-section`}>
                                                                            <ResourceList chapter={chapter} dkp={dkp} delResource={this.delResource} editResource={this.editResource} newResource={this.newResource} newResourceContribution={this.newResourceContribution} />
                                                                        </Tab.Pane>
                                                                    ))
                                                                }
                                                            </Tab.Content>
                                                        </Col>
                                                    </Row>
                                                </Tab.Container>

                                            </Tab.Pane>
                                        ))}
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </div>
                </div>
            )
        } else {
            return (
                <Redirect to="/" />
            )
        }
    }
}

const mapStateToProps = (state) => ({
    auth: authSelector(state),
    chapters: chapterSelector(state),
    dkp: dkpSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getSections: (chapter) => dispatch(fetchSections(chapter)),
    submitNewResource: (chapter, section, data) => dispatch(createResource(chapter, section, data)),
    submitNewResourceContribution: (chapter, section, resource, data) => dispatch(createResourceContribution(chapter, section, resource, data)),
    submitEditResource: (chapter, section, resource, data) => dispatch(updateResource(chapter, section, resource, data)),
    submitDeleteResource: (chapter, section, resource) => dispatch(deleteResource(chapter, section, resource)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Resources);


// WEBPACK FOOTER //
// ./src/Officer/Resources.js